export const trackerCards = [
    {
        title: 'Apple Health',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/applehealth-tracker_yq8u4l.png'
    },
    {
        title: 'Google Fit',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/googlefit-tracker_cu7gpv.png'
    },
    {
        title: 'Garmin',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/garmin-tracker_zi5jqu.png'
    },
    {
        title: 'Fitbit',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/fitbit-tracker_nncb9v.png'
    },
    {
        title: 'Under Armour Run',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/ua-tracker_s0ljey.png'
    },
    {
        title: 'Strava',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/strava-tracker_tf6f7u.png'
    },
    {
        title: 'Striiv',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/striiv-tracker_jpgqix.png'
    },
    {
        title: 'TomTom',
        imageURL:
            'https://res.cloudinary.com/devion-villegas/image/upload/v1622113851/tomtom-tracker_chdjma.png'
    }
]
